import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools }              from '@tanstack/react-query-devtools'
import { ENV }                             from '@constants/env'

/**
 * Global QueryClient configuration.
 *
 * Defaults tuned for a portal app:
 *  - staleTime 60s  → prevents waterfalls on navigating back
 *  - retry 1        → one silent retry on transient failures
 *  - refetchOnWindowFocus false → avoid surprise re-fetches in forms
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:            1000 * 60,    // 60 seconds
      gcTime:               1000 * 60 * 5, // 5 minutes
      retry:                1,
      retryDelay:           (attempt) => Math.min(1000 * 2 ** attempt, 10_000),
      refetchOnWindowFocus: false,
      refetchOnMount:       true,
    },
    mutations: {
      retry: 0,
    },
  },
})

export function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {ENV.ENABLE_DEVTOOLS && (
        <ReactQueryDevtools initialIsOpen={false} position="bottom" />
      )}
    </QueryClientProvider>
  )
}
